import { Component, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { Router } from '@angular/router';
import { URLSearchParams } from '@angular/http';
import { FormControl } from '@angular/forms';

import * as encoding from 'encoding-japanese';
import 'rxjs/Rx';
import { Observable } from 'rxjs/Rx';

import { InstockService } from '../../../service/instock/instock.service';
import { StInstockService } from '../../../service/st-instock/st-instock.service';
import { PdfReportService } from '../../../service/pdf-report/pdf-report.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { HeaderComponent } from '../../../../app/menu/header/header.component';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';
import { insertcomma } from '../../../util/util';
import { AgGridHelper } from '../../../util/AgGridHelper';

@Component({
  selector: 'app-root',
  templateUrl: 'wa1030.component.html',
  styleUrls: ['wa1030.component.scss']
})
export class Wa1030Component implements AfterViewInit {
  private gridApi: any;
  public componentTitle = 'WA1030:格納照会';
  public updprogramCd = 'WA1030';

  @ViewChild(HeaderComponent)
  private headerComponent: HeaderComponent;
  private isShowRemoveModal = false;

  public gridOptions: GridOptions;
  public showGrid: boolean;
  public rowData: any[];

  public ownerId: number;
  public ownerResult: any;

  public config = config;

  public working = false;
  public containerHeight = 500;
  public cardHeight = 500;
  public gridHeight = 500;
  public production = environment.production;
  public backgroundColor: string;

  // for print
  public reporttrnId: number;
  private reportOpened = false;
  private reportTry = 0;
  public url = '#';

  private gridHelper: AgGridHelper;
  private isEnableClearFilter = false;
  private errorInfo = '';

  private isShowSendLoading = false;

  @ViewChild('gridView')
  gridView: ElementRef;

  private selectedCount = 0;
  private paginationGetRowCount = 0;

  private paginationGetTotalPages = 0;
  private paginationGetCurrentPage = 0;

  public rowsPerPageModel = [{ value: 10, viewValue: '10' }, { value: 20, viewValue: '20' }, { value: 100, viewValue: '100' }, { value: 500, viewValue: '500' }];
  public rowsPerPage = config.rowsPerPageSize;

  private isOwnerSearchNone = false;

  private cancel = false;

  private searchValue1 = null;
  private searchValue2 = null;
  private searchValue3 = null;
  private searchValue4 = null;
  private searchValue5 = null;
  private searchValue6 = null;
  private beginDate = null;
  private endDate = null;
  public stinstocks: any[];
  public stinstock = '';

  private isShowSearchBlock = true;

  constructor(
    private router: Router,
    private instockService: InstockService,
    private stInstockService: StInstockService,
    private pdfReportService: PdfReportService,
    private commonService: CommonService,
    private dialogsService: DialogsService
  ) {
    this.gridHelper = new AgGridHelper();
    this.gridOptions = <GridOptions>{
      rowSelection: 'multiple',
      floatingFilter: true,
      enableRangeSelection: true,
      localeText: environment.gridLocale,
      getContextMenuItems: this.getContextMenuItems,
      pagination: true,
      onColumnResized: params => {
        this.saveColumnWidth(params);
      },
      onColumnMoved: () => {
        this.saveColumnOrder();
      },
      onGridReady: params => {
        this.gridApi = params;
        const columns = [];
        for (const column of params.columnApi.getAllDisplayedColumns()) {
          const idx = localStorage.getItem(`wa1030_${column.getColId()}_idx`);
          if (idx !== null) {
            columns.push({ idx: parseInt(idx, 10), column: column });
          }
          columns.sort((a, b) => {
            return a.idx - b.idx;
          });
          for (let i = columns.length - 1; i >= 0; i--) {
            const column = columns[i];
            params.columnApi.moveColumn(column.column, column.idx);
          }
        }

        this.gridHelper.onGridReady();
        this.gridOptions.api.paginationSetPageSize(this.rowsPerPage);
      },
      onFilterChanged: () => {
        this.errorInfo = '';
        this.isEnableClearFilter = this.gridOptions.api.isAnyFilterPresent();
        this.gridHelper.onGridFilterChanged();
      },
      onRowDataChanged: () => {
        this.errorInfo = '';
        this.gridHelper.onRowDataChanged();
      },
      overlayLoadingTemplate: this.gridHelper.TEMPLATE_GRID_LOADING,
      overlayNoRowsTemplate: this.gridHelper.TEMPLATE_GRID_NODATA,
      postProcessPopup: params => {
        this.errorInfo = '';
        this.gridHelper.fixedAgMenu();
      },
      onSortChanged: () => {
        this.errorInfo = '';
        this.gridHelper.renderGridCheckboxImage();
      },
      onSelectionChanged: () => {
        this.errorInfo = '';
        this.selectedCount = this.gridOptions.api.getSelectedRows().length;
      },
      onPaginationChanged: () => {
        this.paginationGetRowCount = this.gridOptions.api.paginationGetRowCount();
        this.paginationGetTotalPages = this.gridOptions.api.paginationGetTotalPages();
        this.paginationGetCurrentPage = this.gridOptions.api.paginationGetCurrentPage() + 1;
        this.gridHelper.renderScrollArrow();
        this.gridHelper.renderGridCheckboxImage();
      }
    };
    this.gridHelper.setGridOptions(this.gridOptions);
    this.gridOptions.columnDefs = [
      {
        headerName: '',
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        width: 30,
        checkboxSelection: true,
        suppressSorting: true,
        suppressFilter: true,
        suppressMenu: true,
        pinned: 'left',
        cellClass: ['tc', 'noCellFocus']
      },
      /*スクロール時にステータスフィールドが消えたら表示するフィールド*/
      {
        headerName: '',
        field: 'col1Scroll',
        suppressMenu: true,
        width: 8,
        cellClass: ['tc', 'cellclass'],
        hide: true,
        pinned: 'left',
        cellStyle: function (params) {
          //ステータス色変化
          if (params.data.stinstockTx == '未入庫') {
            return { backgroundColor: 'rgba(235,153,175,0.2)', color: '#eb99af' };
          } else if (params.data.stinstockTx == '入庫完了') {
            return { backgroundColor: 'rgba(201,202,202,0.2)', color: 'rgba(201,202,202,0.2)' };
          } else {
            return null;
          }
        }
      },
      {
        headerName: '荷主コード',
        field: 'ownerCd',
        width: this.getColumnWidth('ownerCd', 100),
        unSortIcon: true,
        cellClass: ['tl', 'cellclass'],
        suppressMenu: true
      },
      {
        headerName: '荷主名',
        field: 'ownerTx',
        width: this.getColumnWidth('ownerTx', 100),
        unSortIcon: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '入庫ステータス',
        field: 'stinstockTx',
        width: this.getColumnWidth('stinstockTx', 150),
        cellStyle: function (params) {
          //ステータス色変化
          if (params.value == '未入庫') {
            return { backgroundColor: 'rgba(235,153,175,0.2)' };
          } else if (params.value == '入庫完了') {
            return { backgroundColor: 'rgba(201,202,202,0.2)', color: '#b5b4b3' };
          } else {
            return null;
          }
        },
        unSortIcon: true,
        cellClass: ['tc', 'cellclass']
      },
      {
        headerName: '格納指示番号',
        field: 'instocknoCd',
        sort: 'desc',
        width: this.getColumnWidth('instocknoCd', 150),
        unSortIcon: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '商品コード',
        field: 'itemCd',
        width: this.getColumnWidth('itemCd', 100),
        unSortIcon: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '商品名',
        field: 'itemTx',
        width: this.getColumnWidth('itemTx', 200),
        unSortIcon: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'ロット',
        field: 'lotTx',
        width: this.getColumnWidth('lotTx', 100),
        unSortIcon: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '使用期限',
        field: 'uselimitDt',
        width: this.getColumnWidth('uselimitDt', 150),
        unSortIcon: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '入庫日',
        field: 'stockDt',
        width: this.getColumnWidth('stockDt', 150),
        unSortIcon: true,
        cellClass: ['tl', 'cellclass']
      },

      {
        headerName: '入数',
        field: 'amountNr',
        width: this.getColumnWidth('amountNr', 75),
        valueFormatter: insertcomma,
        unSortIcon: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '入庫数',
        field: 'instockNr',
        width: this.getColumnWidth('instockNr', 75),
        valueFormatter: insertcomma,
        unSortIcon: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '入荷番号',
        field: 'arrivenoCd',
        width: this.getColumnWidth('arrivenoCd', 150),
        unSortIcon: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '入荷実績ID',
        field: 'arriveresultId',
        width: this.getColumnWidth('arriveresultId', 150),
        unSortIcon: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '発注番号',
        field: 'arriveordernoCd',
        width: this.getColumnWidth('arriveordernoCd', 100),
        unSortIcon: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '発注行番号',
        field: 'arriveorderdetnoCd',
        width: this.getColumnWidth('arriveorderdetnoCd', 100),
        unSortIcon: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '入荷予定日',
        field: 'arriveplanDt',
        width: this.getColumnWidth('arriveplanDt', 150),
        unSortIcon: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '入荷予定数',
        field: 'arriveplanNr',
        width: this.getColumnWidth('arriveplanNr', 150),
        valueFormatter: insertcomma,
        unSortIcon: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '検品・日時',
        field: 'applyinstockDt',
        width: this.getColumnWidth('applyinstockDt', 150),
        unSortIcon: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '検品・ユーザ名',
        field: 'applyinstockuserTx',
        width: this.getColumnWidth('applyinstockuserTx', 200),
        unSortIcon: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '先ロケーションコード',
        field: 'destlocaCd',
        width: this.getColumnWidth('destlocaCd', 200),
        unSortIcon: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '先ロケーション名',
        field: 'destlocaTx',
        width: this.getColumnWidth('destlocaTx', 150),
        unSortIcon: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '先ロケ・在庫区分',
        field: 'desttypestockTx',
        width: this.getColumnWidth('desttypestockTx', 150),
        unSortIcon: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '先ロケ・開始日時',
        field: 'deststartDt',
        width: this.getColumnWidth('deststartDt', 150),
        unSortIcon: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '先ロケ・終了日時',
        field: 'destendDt',
        width: this.getColumnWidth('destendDt', 150),
        unSortIcon: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '先ロケ・ユーザ名',
        field: 'destuserTx',
        width: this.getColumnWidth('destuserTx', 150),
        unSortIcon: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '更新日時',
        field: 'updDt',
        width: this.getColumnWidth('updDt', 200),
        unSortIcon: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '更新者名',
        field: 'upduserTx',
        width: this.getColumnWidth('upduserTx', 100),
        unSortIcon: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '登録日時',
        field: 'addDt',
        width: this.getColumnWidth('addDt', 200),
        unSortIcon: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '登録者名',
        field: 'adduserTx',
        width: this.getColumnWidth('adduserTx', 100),
        unSortIcon: true,
        cellClass: ['tl', 'cellclass']
      }
    ];
    this.ownerResult = sessionStorage.getItem('ownerResult');
    if (this.ownerResult !== null) {
      const selectedOwner = JSON.parse(this.ownerResult);
      this.ownerId = selectedOwner.ownerId;
    }
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
    this.gridHeight = window.innerHeight - config.headerMargin - config.containerButtonMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  getColumnWidth(id: string, def: number): number {
    return parseInt(localStorage.getItem(`wa1030_${id}_width`), 10) || def;
  }

  saveColumnWidth(params) {
    if (params.finished === true && params.type === 'columnResized') {
      localStorage.setItem(`wa1030_${params.column.colId}_width`, params.column.actualWidth);
    }
  }

  saveColumnOrder() {
    let idx = 0;
    for (const column of this.gridApi.columnApi.getAllDisplayedColumns()) {
      if (column.colId !== '0') {
        localStorage.setItem(`wa1030_${column.colId}_idx`, `${idx}`);
      }
      idx++;
    }
  }

  getContextMenuItems(params) {
    const str_to_unicode_array = str => {
      const arr = [];
      for (let i = 0; i < str.length; i++) {
        arr.push(str.charCodeAt(i));
      }
      return arr;
    };

    const download = csvString => {
      // Unicode コードポイントの配列に変換する
      const unicode_array = str_to_unicode_array(csvString);
      // S-JIS コードポイントの配列に変換
      const sjis_code_array = encoding.convert(
        unicode_array, // ※文字列を直接渡すのではない点に注意
        'SJIS', // to
        'UNICODE' // from
      );
      // 文字コード配列をTypedArrayに変換する
      const uint8_array = new Uint8Array(sjis_code_array);
      // 指定されたデータを保持するBlobを作成する
      const blob = new Blob([uint8_array], { type: 'text/csv' });
      // Internet Explorer
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, 'export.csv');
      } else {
        // Chrome
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = 'export.csv';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    };

    const result = [
      'copy',
      'copyWithHeaders',
      'separator',
      {
        name: 'エクスポート',
        subMenu: [
          {
            name: 'チェックした行をCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv({ onlySelected: true }));
            }
          },
          {
            name: 'すべてCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv());
            }
          },
          'excelExport'
        ]
      }
    ];

    return result;
  }

  ngAfterViewInit() {
    this.gridHelper.el = this.gridView;
    var date = new Date();
    this.beginDate = date.getFullYear() + '-' + this.pad(date.getMonth() + 1, 2) + '-' + this.pad(date.getDate(), 2);

    this.gridOptions.api.setRowData([]);

    this.stInstockService
      .get()
      .then(response => {
        console.log(response);
        this.stinstocks = response['stinstocks'];
      })
      .catch(error => {
        this.stinstocks = [];
      });

    //setTimeout(() => {
    //  if (this.headerComponent.isLogin === true) {
    //    this.onSubmit();
    //  }
    //}, config.waitMsForSearchInNgAfterViewInit);
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
  }

  pad(num, totalStringSize) {
    var asString = num + '';
    while (asString.length < totalStringSize) asString = '0' + asString;
    return asString;
  }

  onResizeGrid(event) {
    this.gridHeight = event.target.innerHeight - config.headerMargin - config.containerButtonMargin;
  }

  changeOwner(selectedOwnerId) {
    this.errorInfo = '';
    console.log(selectedOwnerId);
    if (selectedOwnerId !== null) {
      if (selectedOwnerId !== undefined) {
        this.ownerId = selectedOwnerId;
      } else {
        this.ownerId = undefined;
      }
      this.onSubmit();
    } else {
      this.rowData = [];
      this.gridOptions.api.deselectAll();
    }
  }

  onFilterClear() {
    this.gridOptions.api.setFilterModel(null);
  }

  onSubmit() {
    this.errorInfo = '';
    //SW-2103　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.gridOptions.api.showLoadingOverlay();
    this.selectedCount = 0;
    this.instockService
      .get(
        this.ownerId,
        this.searchValue1,
        this.searchValue2,
        this.searchValue3,
        this.searchValue4,
        this.searchValue5,
        this.searchValue6,
        this.beginDate,
        this.endDate,
        this.stinstocks[this.stinstock] && this.stinstocks[this.stinstock]['stinstockId'] || null
      )
      .then(outputJson => {
          console.log(outputJson);
          this.rowData = outputJson.instocks;
        setTimeout(() => {
          this.searchByKey();
          this.gridOptions.api.hideOverlay();
          this.working = false;
        },300);
      })
      .catch(error => {
        this.working = false;
        this.gridOptions.api.hideOverlay();
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  cxl() {
    //SW-2103　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.isShowSendLoading = true;
    this.errorInfo = '';
    if (this.gridOptions.api.getSelectedNodes().length === 0) {
      this.errorInfo = '対象を選択して下さい';
      this.isShowSendLoading = false;
      this.cancel = false;
      this.working = false;
      return;
    }
    //
    for (let i = 0; i < this.gridOptions.api.getSelectedNodes().length; i++) {
      const data = this.gridOptions.api.getSelectedNodes()[i].data;
      const stinstockTx = data['stinstockTx'];
      if (stinstockTx === '入庫完了'){
        this.errorInfo = '入庫完了の指示はキャンセルできません。';
        this.isShowSendLoading = false;
        this.cancel = false;
        this.working = false;
        return;
      }
    }
    //

    const selectedCds: string[] = [];
    const selectedIds: number[] = [];
    for (let i = 0; i < this.gridOptions.api.getSelectedNodes().length; i++) {
      const data = this.gridOptions.api.getSelectedNodes()[i].data;
      selectedCds.push(data['arrivenoCd']);
      selectedIds.push(data['arriveresultId']);
    }
    // 重複削除
    const arrivenoCds: string[] = Array.from(new Set(selectedCds));
    const arriveresultIds: number[] = Array.from(new Set(selectedIds));
    console.log(arrivenoCds);
    console.log(arriveresultIds);

    this.instockService
      .cancel(arrivenoCds, arriveresultIds, this.updprogramCd)
      .then(outputJson => {
        this.isShowSendLoading = false;
        this.working = false;
        this.onSubmit();
        sessionStorage.setItem('SuccessInfoMessage', 'キャンセルが完了しました');
        this.cancel = false;
      })
      .catch(error => {
        this.isShowSendLoading = false;
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
        this.cancel = false;
      });
  }

  printKanban() {
    //SW-2103　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.isShowSendLoading = true;
    this.errorInfo = '';
    if (this.gridOptions.api.getSelectedNodes().length === 0) {
      this.errorInfo = '対象を選択して下さい';
      this.isShowSendLoading = false;
      this.working = false;
      return;
    }
    // Change the flag of working to true in order to disable the submit button

    const selectIds: object[] = [];
    var selectedCount = this.gridOptions.api.getSelectedNodes().length;
    for (let i = 0; i < this.gridOptions.api.getSelectedNodes().length; i++) {
      const rowIndex: number = +this.gridOptions.api.getSelectedNodes()[i]['id'];
      const jsonUnit: object = {
        selectId: this.rowData[rowIndex]['instockId']
      };
      selectIds.push(jsonUnit);
    }
    console.log(selectIds);
    // Reset the flag to indicate that the report has not been opened yet
    this.reportOpened = false;
    // Reset the limit counter
    this.reportTry = 0;
    // Submit the request to generate the report
    this.pdfReportService
      .post(0, 'TA_INSTOCK', 'RA9001', 0, 'wa1030', selectIds)
      .then(outputJson => {
        this.reporttrnId = outputJson.reporttrnId;
		// Call the PDF report service
        this.pdfReportService
          .printReport('RA9001', this.reporttrnId)
          .then(outputJson => {
              // Change the working flag to false in order to enable the submit button
              this.working = false;
			  this.isShowSendLoading = false;
              const url = environment.pdfPath + outputJson.pdfFilename;
              this.openReport(url);
           })
          .catch(error => {
             // Change the working flag to false in order to enable the submit button
             this.working = false;
			 this.isShowSendLoading = false;
             console.log(this.commonService.getErrorMessage(error));
             this.errorInfo = this.commonService.getErrorMessage(error);
           });
      })
      .catch(error => {
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
        this.isShowSendLoading = false;
        this.working = false;
      });
  }

  waitResult() {
    this.isShowSendLoading = true;
    const obs = Observable.interval(1000).subscribe(() => {
      // Verify that we have not tried more than 10 times
      if (this.reportTry <= 10) {
        // Add a new try to the counter
        this.reportTry++;
        // Call the PDF report service
        this.pdfReportService
          .get(this.reporttrnId)
          .then(outputJson => {
            // seems we can get the report path correctly
            // If the createdFl is 0 the report has not finished so we retry again.
            // If the createdFl is 1 we get the report name and open a new window to show the PDF file.
            if (outputJson.reports[0].createdFl === 1) {
              // Cancel the Observable when success
              obs.unsubscribe();
              // Change the working flag to false in order to enable the submit button
              this.isShowSendLoading = false;
              const url = environment.bucketUrl + '/report/' + outputJson.reports[0].reportpathTx;
              // We open a new tab to display the PDF.
              // If preferred we could get the PDF data and send the blob to the new tab instead.
              this.openReport(url);
            }
            if (outputJson.reports[0].createdFl === -1) {
              // Cancel the Observable when success
              obs.unsubscribe();
              this.isShowSendLoading = false;
              this.errorInfo = '対象データがないため帳票が作成できませんでした。';
            }
          })
          .catch(error => {
            // Cancel the Observable in case of error
            obs.unsubscribe();
            // Change the working flag to false in order to enable the submit button
            this.isShowSendLoading = false;
            console.log(this.commonService.getErrorMessage(error));
            this.errorInfo = this.commonService.getErrorMessage(error);
          });
      } else {
        // Cancel the Observable if the number of tries maxed out
        obs.unsubscribe();
        // Change the working flag to false in order to enable the submit button
        this.isShowSendLoading = false;
        this.errorInfo = '帳票を取得できませんでした（タイムアウト）。再発する場合は管理者へ連絡してください。';
      }
    });
  }

  // Open the newly generated report on a different tab/window
  openReport(url) {
    // Verify that the report has not been opened already in cases where the network response is slow
    // and we get multiple responses at the same time.
    if (this.reportOpened === false) {
      this.url = url;
      this.isShowRemoveModal = true;
      // Change the flag to indicate that the report was already opened
      this.reportOpened = true;
    }
  }

  confirmOk() {
    const popup_window = window.open(this.url);
    try {
      popup_window.focus();
    } catch (e) {
      this.isShowRemoveModal = false;
    }
  }

  // 商品ラベル出力
  printItemLabel() {
    if (this.gridOptions.api.getSelectedNodes().length === 0) {
      this.isShowSendLoading = false;
      this.errorInfo = '対象を選択して下さい';
      return;
    }
    this.isShowSendLoading = true;
    const selectIds: object[] = [];
    for (let i = 0; i < this.gridOptions.api.getSelectedNodes().length; i++) {
      const rowIndex: number = +this.gridOptions.api.getSelectedNodes()[i]['id'];
      // push data
      const jsonUnit: object = {
        selectId: this.rowData[rowIndex]['instockId']
      };
      selectIds.push(jsonUnit);
    }
    sessionStorage.setItem('wa1030-instockId-itemLabel', JSON.stringify(selectIds));
    this.isShowSendLoading = false;
    this.router.navigate(['wa1031']);
  }

  paginatorRowChange() {
    this.gridOptions.api.paginationSetPageSize(this.rowsPerPage);
  }

  ownerInputChanged(ownerId: string) {
    this.gridHelper.isOwnerNotFound = ownerId == null && ownerId !== undefined;
    this.changeOwner(ownerId);
  }

  onSearchBlockClick() {
    this.errorInfo = '';

    this.isShowSearchBlock = !this.isShowSearchBlock;
    this.gridHelper.renderScrollArrowDelay();
  }

  clrErr() {
    this.errorInfo = '';
  }

  clearSearchKey() {
    this.errorInfo = '';
    this.searchValue1 = null;
    this.searchValue2 = null;
    this.searchValue3 = null;
    this.searchValue4 = null;
    this.searchValue5 = null;
    this.searchValue6 = null;
    this.beginDate = null;
    this.endDate = null;
    this.stinstock = '';
  }

  searchByKey() {
    var filters = {};
    if (this.searchValue1 != null && this.searchValue1.length > 0) {
      filters['itemCd'] = {
        type: 'contains',
        filter: this.searchValue1
      };
    }
    if (this.searchValue2 != null && this.searchValue2.length > 0) {
      filters['itemTx'] = {
        type: 'contains',
        filter: this.searchValue2
      };
    }
    if (this.searchValue3 != null && this.searchValue3.length > 0) {
      filters['arrivenoCd'] = {
        type: 'contains',
        filter: this.searchValue3
      };
    }
    if (this.searchValue4 != null && this.searchValue4.length > 0) {
      filters['instocknoCd'] = {
        type: 'contains',
        filter: this.searchValue4
      };
    }
    if (this.searchValue5 != null && this.searchValue5.length > 0) {
      filters['destlocaCd'] = {
        type: 'contains',
        filter: this.searchValue5
      };
    }
    if (this.searchValue6 != null && this.searchValue6.length > 0) {
      filters['destlocaTx'] = {
        type: 'contains',
        filter: this.searchValue6
      };
    }
    if (this.stinstock != null && this.stinstock.length > 0) {
      filters['stinstockTx'] = {
        type: 'equals',
        filter: this.stinstocks[this.stinstock]['stinstockTx']
      };
    }

    this.gridApi.api.setFilterModel(null);
    if (Object.getOwnPropertyNames(filters).length == 0) return;
    console.log(filters);
    this.gridApi.api.setFilterModel(filters);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa1Arrival/wa1030/wa1030.component.ts